import {
  LinearProgress,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

const CustomTable = ({
  tableColumns,
  tableRows,
  fetchingStatus = "succeeded",
  customCell: CustomCell = null,
  showSkeleton = false,
  currentTab,
}) => {
  return showSkeleton ? (
    <Skeleton
      sx={{ borderRadius: "8px" }}
      variant="rectangular"
      width={"100%"}
      height={500}
    />
  ) : (
    <TableContainer
      sx={{
        maxHeight: 500,
        overflowY: "auto",
        tableLayout: "fixed",
        width: "100%",
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {tableColumns?.map((column) => (
              <TableCell
                key={column.id}
                align={"center"}
                sx={{
                  backgroundColor: "gray.g200",
                  height: "40px",
                  paddingY: "0px",
                  borderBottom: "0px",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "gray.g500", whiteSpace: "nowrap" }}
                >
                  {column.label}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {fetchingStatus === "loading" && (
            <TableRow>
              <TableCell
                colSpan={tableColumns?.length}
                sx={{
                  borderBottom: "0px",
                  padding: "0px",
                }}
              >
                <LinearProgress />
              </TableCell>
            </TableRow>
          )}

          {fetchingStatus === "succeeded" && tableRows?.length === 0 && (
            <TableRow width="100%">
              <TableCell
                colSpan={tableColumns?.length}
                align="center"
                sx={{
                  borderBottom: "0px",
                }}
              >
                <Typography fontWeight={600} sx={{ color: "gray.g600" }}>
                  No Data Available
                </Typography>
              </TableCell>
            </TableRow>
          )}

          {tableRows?.map((row, index) => {
            return (
              <TableRow key={`row-${currentTab}-${index}`}>
                {tableColumns?.map((column) => {
                  const value = row[column.id];
                  return CustomCell ? (
                    <CustomCell
                      column={column}
                      row={row}
                      currentTab={currentTab}
                      key={`cell-${currentTab}-${column.id}-${index}`}
                    />
                  ) : (
                    <TableCell
                      key={`cell-${currentTab}-${column.id}-${index}`}
                      align={"center"}
                      size="medium"
                      sx={{
                        backgroundColor: "background.paper",
                        color: "text.primary",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Typography variant="body2">
                        {typeof value !== "object" && value}
                      </Typography>
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;